module.exports = __webpack_public_path__ + "img/gi_ayamjagoan.ad5a6e80.png";